import {
  createMemoryRouter,
  IndexRouteObject,
  LoaderFunctionArgs,
  NonIndexRouteObject,
  RouteObject,
} from 'react-router-dom'

import { JourneyRouterContext } from '@cash-web/shared-journey-util-main'

type MemoryRouterOptions = Parameters<typeof createMemoryRouter>[1]

type LoaderWithContext<TContext> = (
  args: LoaderFunctionArgs & { context: TContext }
) => ReturnType<NonNullable<IndexRouteObject['loader']>>

export type RouteObjectWithContext<TContext = unknown> = (
  | Omit<IndexRouteObject, 'loader'>
  | (Omit<NonIndexRouteObject, 'loader' | 'children'> & { children?: RouteObjectWithContext<TContext>[] })
) & {
  loader?: LoaderWithContext<TContext>
  appName?: 'account' | 'support'
}

function transformRoutes(
  routes: RouteObjectWithContext<JourneyRouterContext>[],
  context: JourneyRouterContext
): RouteObject[] {
  return routes.map(({ loader, children, index, appName = 'account', ...route }) => {
    if (index) {
      return {
        ...route,
        index: true,
        loader: loader ? args => loader({ ...args, context }) : undefined,
      }
    }

    return {
      ...route,
      loader: loader ? args => loader({ ...args, context }) : undefined,
      children: children ? transformRoutes(children, context) : undefined,
    }
  })
}

export function createMemoryRouterWithContext(
  routes: RouteObjectWithContext<JourneyRouterContext>[],
  opts: MemoryRouterOptions,
  context: JourneyRouterContext
) {
  const transformedRoutes = transformRoutes(routes, context)
  return createMemoryRouter(transformedRoutes, opts)
}
